import { render, staticRenderFns } from "./ClientLoadingBaseClassSelect.vue?vue&type=template&id=23f9fa7b&lang=pug"
import script from "./ClientLoadingBaseClassSelect.vue?vue&type=script&lang=js"
export * from "./ClientLoadingBaseClassSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports